import React from "react";
import Dashboard from "../Dashboard";
import AbandonedWishlistComp from "../../../features/adminDashboard/abandonedWishlist/AbandonedWishlistComp";

function AbandonedWishlist() {
  return (
    <Dashboard>
      <AbandonedWishlistComp />
    </Dashboard>
  );
}

export default AbandonedWishlist;
